import gql from 'graphql-tag';

export const DESTROY_STOCKTAKE = gql`
	mutation destroyStocktakeMutation($id: ID!) {
		destroyStocktake(id: $id)
	}
`;
